// ============================================
// Calibration Run Firestore Service
// Collection: calibration_runs/{runId}
// ============================================

import {
  collection, doc, getDoc, getDocs, setDoc, updateDoc,
  query, orderBy, limit as firestoreLimit,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../firebase';
import type { CalibrationRun } from '../../types/calibrationRun';

import { C_CALIBRATION_RUNS } from '../../constants/collections';
const runsCol = () => collection(db, C_CALIBRATION_RUNS);

/** Save a calibration run (create or overwrite). */
export async function saveCalibrationRun(run: CalibrationRun): Promise<void> {
  await setDoc(doc(runsCol(), run.runId), {
    ...run,
    _updatedAt: Timestamp.now(),
  });
}

/** Update a running calibration (partial). */
export async function updateCalibrationRun(
  runId: string,
  updates: Partial<CalibrationRun>,
): Promise<void> {
  await updateDoc(doc(runsCol(), runId), {
    ...updates,
    _updatedAt: Timestamp.now(),
  });
}

/** Get a single run by ID. */
export async function getCalibrationRun(
  runId: string,
): Promise<CalibrationRun | null> {
  const snap = await getDoc(doc(runsCol(), runId));
  return snap.exists() ? (snap.data() as CalibrationRun) : null;
}

/** Get recent calibration runs (newest first). */
export async function getRecentCalibrationRuns(
  max = 20,
): Promise<CalibrationRun[]> {
  const q = query(runsCol(), orderBy('startedAt', 'desc'), firestoreLimit(max));
  const snap = await getDocs(q);
  return snap.docs.map((d) => d.data() as CalibrationRun);
}
